import * as Paginator from "react-bootstrap-table2-paginator";

import { Card, Col, Form, Row } from "react-bootstrap";
import { Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import ToolkitProvider, { CSVExport, Search, } from "react-bootstrap-table2-toolkit";
import { faPlus, faSearch, faDownload } from "@fortawesome/free-solid-svg-icons";
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';

import Axios from "../../utils/axiosInstance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Pagination from "react-bootstrap-table2-paginator";
import Select from "react-select";
import Table from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import fileSaver from "file-saver";
import { getServiceEngWise, } from "../../Service/AllReportAPI";
import { getServiceEngineerList, } from "../master/AllUserDropDown";
import { getUserEntry, } from "../../Service/AllUserEntryAPI";
import swal from "sweetalert";

//import * as Yup from "yup";

export default () => {
  const [entries, setEntries] = useState([]);
  const [changeRowData, setChangeRowData] = useState({
    selectedRow: [],
    cellChange: "",
    columnChange: [],
  });
  const [serviceEngineerName, setServiceEngineerName] = useState([]);
  const [selectedServiceEngineer, setSelectedServiceEngineer] = useState("");
  // --- pagination
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoaded, setisLoaded] = useState(false);

  useEffect(() => {
    // Function call to get Dispatch list
    getUserList();
    getServiceEngList();
    // eslint-disable-next-line
  }, []);

  // Function declaration of get customers list
  const  getServiceEngList = async () => {
    await getServiceEngineerList()
    .then((result) => {
      setServiceEngineerName(result);
    });
  };

  const handlePageChange = async (page) => {
    setEntries([]);
    const selectedPage = page - 1;
    console.log("selectedPage", selectedPage);
    if (selectedServiceEngineer === "") {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers= {Authorization : `Bearer ${token}`}
      await getUserEntry(selectedPage, fkUserId, role, headers)
      .then((result) => {
        console.log("Get Pagination service engg Result", result);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          const totalSize = result.data.pageable.offset;
          console.log("data", data);
          setEntries(data);
          setPageCount(result.data.totalPages);
          setTotaloffset(totalSize);
          entries.map((item, index) => (item.id = totalSize + index + 1));
        } else {
          swal("Sorry", "Data is not present", "warning");
        }
      })
      .catch((error) => console.error("Error", error));
    }
      //Customer wise pagination
      else if (selectedServiceEngineer !== "") {
        await getServiceEngWise(selectedPage,selectedServiceEngineer)
        .then((result) => {
          console.log("Get Pagination Dealer Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            console.log("data", data);
            setEntries(data);
            setPageCount(result.data.totalPages);
            setTotaloffset(totalSize);
            entries.map((item, index) => (item.id = totalSize + index + 1));
          } else {
            setEntries([]);
            setPageCount();
            setTotalCount();
            swal("Sorry", "Data is not present", "warning");
          }
        })
        .catch((error) => console.error("Error", error));
    }
  };

  const getUserList = async () => {
    try {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers= {"Authorization" : `Bearer ${token}`}
      await getUserEntry(currentPage, fkUserId, role, headers)
      .then((result) => {
        console.log("Get User Entry Result", result);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          setEntries(data);
          setPageCount(result.data.totalPages);
          setTotalCount(result.data.totalElements);
        } else {
          setEntries([]);
          setPageCount();
          setTotalCount();
        }
      })
      .catch((error) => {
        console.log("Get User Entry Error", error);
      });
    } catch (error) {
      console.log(error);
      swal( "Failed", "Something went wrong please check your internet", "error" );
    }
  };

  const getServiceEngWisePdfDownload = async (e) => {
    try {
      if (selectedServiceEngineer !== "") {
        setisLoaded(true);
        let token = sessionStorage.getItem("token");
        let fileType = ["Pdf"];
        return Axios.get(
          `/petrotec/getServiceEngineerNameWiseReportForUserPdf?fileType=${fileType}&serviceEngineerName=${selectedServiceEngineer}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "arraybuffer",
          }
        )
        .then((response) => {
          var blob = new Blob([response.data], { type: "application/pdf" });
          fileSaver.saveAs(blob, `serviceengineernamewiseuserreport.pdf`);
          setisLoaded(false);
        });
      } else {
        swal("Failed", "Please Select Dealer Name", "error");
      }
    } catch (error) {
      setisLoaded(false);
      console.log(error);
      swal( "Failed", "Something went wrong please check your internet", "error" );
    }
  };

  const getServiceEngWiseExcelDownload = async (e) => {
    try {
      if (selectedServiceEngineer !== "") {
        let token = sessionStorage.getItem("token");
        let fileType = ["Excel"];
        return Axios.get(`petrotec/getServiceEngineerNameWiseReportForUserPdf?fileType=${fileType}&serviceEngineerName=${selectedServiceEngineer}`, {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "arraybuffer",
        })
        .then((result) => {
          let blob = new Blob([result.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
          fileSaver.saveAs(blob, "serviceengineernamewiseuserreport.xlsx");
        });
      } else {
        swal("Failed", "Please Select Dealer Name", "warning");
      }
    } catch (error) {
      console.log("getServiceEngWiseExcelDownload error :-", error);
      swal("Failed", "Something went wrong please check your internet", "error");
    };
  };


  // Adding srno column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));
  // Column heading of Service Engineer list
  const columns = [
    { dataField: "id", text: "Sr. No." },
    {
      dataField: "firstName",
      text: "First Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "lastName",
      text: "Last Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "companyName",
      text: "Company Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "role",
      text: "Designation",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "userName",
      text: "Username",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "email",
      text: "User Email",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "mobileNo",
      text: "Mobile No.",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "description",
      text: "Description",
      editable: false,
      headerAlign: "left",
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && (
            <span className="tooltip-text">{row.description}</span>
          )}
        </div>
      )
    },
    {
      dataField: "address",
      text: "Address",
      editable: false,
      style: { textTransform: "capitalize",},
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && (
            <span className="tooltip-text">{row.address}</span>
          )}
        </div>
      )
    },
    

    {
      dataField: "country",
      text: "Country",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "state",
      text: "State",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "city",
      text: "City",
      editable: false,
      headerAlign: "left",
    },
    
  ];

  // custom the pagination total
  const customTotal = (from, to, size) => (
    <div>
      Showing {totaloffset + from} to {totaloffset + to} of {size} entries
    </div>
  );

  // callback function when page was changing
  const customSizePerPage = (props) => {
    const { options, currentSizePerPage, onSizePerPageChange } = props;
    const onPageChange = (e) => {
      const page = e.target.value;
      onSizePerPageChange(page);
    };

    return (
      <>
        <Row>
          <Col xs="auto">
            <Form.Select
              value={currentSizePerPage}
              onChange={onPageChange}
              className="pe-5"
            >
              {options.map((o) => (
                <option key={o.page} value={o.page}>
                  {o.text}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            Entries per page
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      {isLoaded ? (
        <div className="reportload"></div>
      ) : (
        <Formik
          initialValues={{}}
          onSubmit={async (values) => {
            console.log(JSON.stringify(values, null, 2));
          }}
        >
          {(formik) => {
            return (
              <>
                <Row>
                  <Col md={6} className="mb-3">
                    <div className="form-group">
                      <label className="Label mb-1" >Service Engineer Name</label>
                      <Select
                        id="serviceEngineerName"
                        placeholder="Select Service Engineer Name"
                        title="Select Service Engineer Name"
                        options={serviceEngineerName}
                        onChange={async (e) => {
                          formik.setFieldValue("serviceEngineerName", e.value);
                          setSelectedServiceEngineer(e.value);
                          await getServiceEngWise(currentPage, e.value)
                          .then((result) => {
                            console.log("Service Engineer Details", result);
                            if (result?.data?.content?.length !== 0) {
                              const data = result.data.content;
                              setEntries(data);
                              setPageCount(result.data.totalPages);
                              setTotalCount(result.data.totalElements);
                            } else {
                              setEntries([]);
                              setPageCount();
                              setTotalCount();
                              swal("Sorry", "Data is not present", "warning");
                            }
                          })
                          .catch((error) => {
                            console.log("Service Engineer list Error", error);
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
{/* --- When you use any toolkit functionalities, you are supposed to render toolkit component and
  BootstrapTable as the children of ToolkitProvider --- */}
                <ToolkitProvider
                  keyField="id"
                  search={true}
                  columns={columns}
                  data={entries}
                  exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                >
                  {({ baseProps, searchProps, csvProps }) => (
                    //render the Pagination component as a list with left and right arrows
                    <Paginator.PaginationProvider
                      pagination={Pagination({
                        custom: true,
                        disablePageTitle: true,
                        alwaysShowAllBtns: true,
                        totalSize: totalCount,
                        paginationTotalRenderer: customTotal,
                        onPageChange : handlePageChange,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <Card>
                          <div className="table-responsive py-2">
                            <Card.Header>
                              <Row>
                                <Col xs={12} md={6} className="py-1">
                                  {/* <Paginator.SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  /> */}
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex justify-content-md-end py-1"
                                >
                                  {/* props for search component */}
                                  {/* <Search.SearchBar {...searchProps} />{" "} */}
                                  {/* props for csv component */}
                                  {/* <ExportCSVButton
                                    {...csvProps}
                                    className="btn btn-secondary mx-2"
                                  >
                                    <span>CSV</span>{" "}
                                  </ExportCSVButton> */}
                                  <button
                                    className="btn btn-secondary"
                                    onClick={getServiceEngWisePdfDownload}
                                  >
                                    <FontAwesomeIcon icon={faDownload} className="me-2" />
                                    <span>PDF</span>{" "}
                                  </button>
                                  <button
                                    className="btn btn-secondary mx-2"
                                    onClick={getServiceEngWiseExcelDownload}
                                  >
                                    <FontAwesomeIcon icon={faDownload} className="me-2" />
                                    <span>Excel</span>
                                  </button>
                                </Col>
                              </Row>
                            </Card.Header>
                            <Table
                              {...baseProps}
                              {...paginationTableProps}
                              bodyClasses="border-0"
                              rowClasses="border-bottom"
                              classes="table-flush dataTable-table"
                            // selectRow={selectRow}
                              filter={filterFactory()}
                              headerClasses="header-class"
                              hover
                              striped
                              condensed
                              remote= {{pagination:true}}
                              cellEdit={cellEditFactory({
                                mode: "click",
                                blurToSave: true,
                                afterSaveCell: (
                                  oldValue,
                                  newValue,
                                  row,
                                  column
                                ) => {
                                  const changeRowData = {
                                    selectedRow: row,
                                    cellChange: newValue,
                                    columnChange: column,
                                  };
                                  setChangeRowData(changeRowData);
                                },
                              })}
                              wrapperClasses="table-responsive"
                            />
                            <Card.Footer>
                              <Row>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex align-items-center py-1"
                                >
                                    {/* <Paginator.PaginationTotalStandalone
                            {...paginationProps}
                          /> */}
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                                >
                                  <Paginator.PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </Card.Footer>
                          </div>
                        </Card>
                      )}
                    </Paginator.PaginationProvider>
                  )}
                </ToolkitProvider>
              </>
            );
          }}
        </Formik>
      )}
    </>
  );
};
// }};
